<template>
  <div class="box">
    <headerPage :orgInfo="org_info"/>
<!--    <div class="boxTop">-->
<!--      <div class="img">-->
<!--        <img :src="org_info.morglogo" alt="">-->
<!--      </div>-->
<!--      <div class="name">{{org_info.morgname}}</div>-->
<!--    </div>-->
    <div class="jigou-detail">
      <div class="jigou-box">
<!--        <div class="jigou-btn">-->
<!--          <span @click="to">申请入驻</span>-->
<!--        </div>-->
        <div class="jigou-tex" v-if="show_config.is_org == 1" v-html="org_info.morgdesc"></div>
        <div class="jigou-tex" v-else></div>
         <div class="tab">
           <span :class="{active : active === 0}" @click="active = 0">全部</span>
           <span v-for="item in expert_type" :key="item.id" :class="{active : active === item.id}" @click="active = item.id">{{item.name}}</span>
         </div>
      </div>
    </div>
    <div class="box-end">
      <div class="bx-content">
        <div class="search-box">
          <div class="select-box">
            共上传<span>{{ total_number }}+</span>专家
          </div>
          <div class="input-box h50">
            <el-input v-model="input" placeholder="请输入专家姓名" style="width: 100%;height: 50px;"></el-input>
            <div @click="jgList(0)">
              <i class="iconfont icon-sousuo"></i>
              <span>搜索</span>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="item" v-for="item in expert_list" :key="item.id">
            <div class="ltem-l">
              <div class="img" @click="yuyue(item.id)">
                <img :src="urlStr + item.pic" alt="">
              </div>
              <div class="btn" @click="open(item.id)">预约</div>
            </div>
            <div class="ltem-r" @click="yuyue(item.id)">
              <div class="name">{{item.name}}</div>
              <div class="tex ovHide2">{{item.job_text}}</div>
              <div class="xian"></div>
              <div class="p">
                <el-tooltip effect="dark" :content="item.desc" placement="bottom" popper-class="tool-tip">
                  <p class="ovHide4">
                    {{item.desc}}
                    <!-- <span @click="yuyue(item.id)">【详情】</span>-->
                  </p>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="more">
          <p v-if="expert_list_show"  @click="jgList(1)">
            加载更多 <i class="iconfont icon-shanglajiantou"></i>
          </p>
          <p v-else>
            暂无更多...
          </p>
        </div>
      </div>
      <div class="bac">
        <div class="bx-content">
          <div class="tit">热门专家</div>
          <div class="list">
            <div class="coniter" v-for="item in hotList" :key="item.id">
              <div class="img">
                <img :src="urlStr + item.pic" alt="">
              </div>
              <div class="name">
                <b>{{item.name}}</b>
                <span>{{item.expert_type}}</span>
              </div>
              <div class="tex ovHide2">{{item.job_text}}</div>
              <div class="detail">
                <div class="d-name"  @click="yuyue(item.id)">
                  <div class="d-b">{{item.name}}</div>
                  <div class="d-s">{{item.expert_type}}</div>
                </div>
                <div class="d-tex ovHide2"  @click="yuyue(item.id)">{{item.job_text}}</div>
                <div class="d-xian"></div>
                <div class="d-p"  @click="yuyue(item.id)">
                  <el-tooltip effect="dark" :content="item.desc" placement="bottom" popper-class="tool-tip">
                    <p class="ovHide4">
                      {{item.desc}}
                      <!-- <span @click="yuyue(item.id)">【详情】</span>-->
                    </p>
                  </el-tooltip>
                </div>
                <div class="d-btn">
                  <span @click="open(item.id)">预约</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="show_config.is_tui == 1">
            <div class="tit" style="margin: 30px 0;">系统推荐专家</div>
            <div class="search-box">
              <div class="select-box h50">
                <el-select v-model="value" placeholder="全部领域">
                  <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="input-box h50">
                <el-input v-model="inputTwo" placeholder="请输入专家姓名" style="width: 100%;"></el-input>
                <div @click="tjList(0)">
                  <i class="iconfont icon-sousuo"></i>
                  <span>搜索</span>
                </div>
              </div>
            </div>
            <div class="list asd">
              <div class="item" v-for="item in expert_recommend" :key="item.id">
                <div class="ltem-l">
                  <div class="img"  @click="yuyue(item.id)">
                    <img :src="urlStr + item.pic" alt="">
                  </div>
                  <div class="btn" @click="open(item.id)">预约</div>
                </div>
                <div class="ltem-r"  @click="yuyue(item.id)">
                  <div class="name">{{item.name}}</div>
                  <div class="tex ovHide2">{{item.job_text}}</div>
                  <div class="xian"></div>
                  <div class="p">
                    <el-tooltip effect="dark" :content="item.desc" placement="bottom" popper-class="tool-tip">
                      <p class="ovHide4">
                        {{item.desc}}
                        <!-- <span @click="yuyue(item.id)">【详情】</span>-->
                      </p>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div class="more">
              <p v-if="expert_recommend_show" @click="tjList(1)">
                加载更多 <i class="iconfont icon-shanglajiantou"></i>
              </p>
              <p v-else>
                暂无更多...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerPage/>
    <el-dialog
        title=""
        :visible.sync="dialogFormVisible"
        custom-class="shenqBox"
        center
    >
      <div slot="title" style="font-size: 18px;font-weight:bold;">预约专家</div>
      <el-form :model="formA" :rules="rules" ref="formA" class="demo-ruleForm">
        <el-form-item label="姓名：" :label-width="formLabelWidth"  prop="name">
          <el-input v-model="formA.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" :label-width="formLabelWidth"  prop="tel" required>
          <el-input v-model="formA.tel" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="申请说明：" :label-width="formLabelWidth" prop="content">
          <el-input typr="textarea" v-model="formA.content" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="dialogFormVisible = false" style="width: 100px;height: 40px;">取 消</el-button>
        <el-button round type="primary" @click="submitForm('formA')" style="background-color: #ff9600;width: 100px;height: 40px;margin-left: 40px;border-color: #ff9600;">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerPage from '../home/common/headPage'
import footerPage from '../home/common/footPage'
import {hot, index_page, index_page_recommend, indexShow, yuyueSub} from "@/api";
import {urlStr} from "@/config";
export default {
  name: "login",
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    return {
      id:'',
      urlStr: urlStr,
      showId:'',
      register_type:'',
      active: 0,
      input:'',
      inputTwo:'',
      options: [],
      value: '',
      dialogFormVisible: false,
      formLabelWidth: '120px',
      expert_list_show:true,
      expert_recommend_show:true,
      expert_recommend_page: 1,
      expert_list_page:1,
      show_config:{
        is_tui:1,
        is_org:1,
        login_show:0,
        login_yuyue:0
      },
      org_info:{},
      expert_recommend:[],
      expert_list:[],
      expert_type:[],
      total_number:[],
      hotList:[],
      formA: {
        name: '',
        content: '',
        tel: '',
      },
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入申请说明', trigger: 'blur' }
        ],
        tel: [
          { validator: validatePass, trigger: 'blur' }
        ],
      }
    }
  },
  components: {
    headerPage,
    footerPage
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.showId = this.$route.query.showId
    this.register_type = this.$route.query.register_type
    this.detail()
    this.hot()
  },
  methods: {

    open(id){
      if(this.show_config.login_yuyue == 1 && !this.user) {
        this.$confirm('该操作需要登录，是否去登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({
            path:'/login',
            query:{
              rout:`/expert?showId=${this.showId}&register_type=${this.register_type}`
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }else {
        this.dialogFormVisible = true
        this.id = id
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sub()
        } else {
          this.$message.error('请检查是否填写完整');
          return false;
        }
      });
    },

    async sub(){
      let _res = await yuyueSub(
          this.user ? this.user.mid : '',
          this.showId,
          this.id,
          this.formA.name,
          this.formA.tel,
          this.formA.content,
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg);
        this.dialogFormVisible = false
      }else {
        this.$message.error(_res.msg);
      }
    },

    //
    async detail() {
      let _res = await indexShow(
          this.showId,
          this.value, this.expert_recommend_page, 9,
          this.active, this.expert_list_page, 9
      );
      if (_res.status === 200) {
        if (this.expert_list_page === 1 && this.expert_recommend_page === 1) {
          this.show_config = _res.data.show_config
          this.org_info = _res.data.org_info
          this.org_info.showId = this.showId
          this.expert_type = _res.data.expert_type
          this.options = _res.data.expert_recommend_type
          this.expert_recommend = _res.data.expert_recommend.data
          this.expert_list = _res.data.expert_list.data
          this.total_number = _res.data.expert_list.total_number
          this.expert_list.map(item => {
            let ary = JSON.parse(item.job)
            let arr = []
            ary.map(itm => {
              arr.push(itm.value)
            })
            item.job_text = arr.join('、')
          })
          this.expert_recommend.map(item => {
            let ary = JSON.parse(item.job)
            let arr = []
            ary.map(itm => {
              arr.push(itm.value)
            })
            item.job_text = arr.join('、')
          })
        }

      } else {
        this.$message.error(_res.msg);
      }
    },

    // 机构专家列表
    async jgList(page){
      if(this.show_config.login_show == 1 && !this.user){
        this.$confirm('该操作需要登录，是否去登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({
            path:'/login',
            query:{
              rout:`/expert?showId=${this.showId}&register_type=${this.register_type}`
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
        return
      }
      if(page === 0){
        this.expert_list_page = 1
        this.expert_list_show = true
      }else {
        this.expert_list_page++
      }
      let _res = await index_page(
        this.user ? this.user.mid : '',
          this.showId,
          this.input,this.active,
          this.expert_list_page,
          9
      );
      if (_res.status === 200) {
        var list = []
        list = _res.data
        if(_res.data.length === 0){
          this.expert_list_show = false
          if(this.expert_list_page === 1){
            this.expert_list = []
          }
          this.$message.info('暂无更多...')
          return
        }
        list.map(item => {
          let ary = JSON.parse(item.job)
          let arr = []
          ary.map(itm => {
            arr.push(itm.value)
          })
          item.job_text = arr.join('、')
        })
        if(this.expert_list_page === 1){
          this.expert_list = list
        }else {
          this.expert_list = this.expert_list.concat(list)
        }
      } else {
        this.$message.error(_res.msg)
      }
    },

    // 推荐专家列表
    async tjList(page){
      if(this.show_config.login_show == 1 && !this.user){
        this.$confirm('该操作需要登录，是否去登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({
            path:'/login',
            query:{
              rout:`/expert?showId=${this.showId}&register_type=${this.register_type}`
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
        return
      }
      if(page === 0){
        this.expert_recommend_page = 1
        this.expert_recommend_show = true
      }else {
        this.expert_recommend_page++
      }
      let _res = await index_page_recommend(
        this.user ? this.user.mid : '',
          this.showId,
          this.inputTwo,this.value,
          this.expert_recommend_page,
          9
      );
      if (_res.status === 200) {
        var list = []
        list = _res.data
        if(_res.data.length === 0){
          this.expert_recommend_show = false
          if(this.expert_recommend_page === 1){
            this.expert_recommend = []
          }
          this.$message.info('暂无更多...')
          return
        }
        list.map(item => {
          let ary = JSON.parse(item.job)
          let arr = []
          ary.map(itm => {
            arr.push(itm.value)
          })
          item.job_text = arr.join('、')
        })
        if(this.expert_recommend_page === 1){
          this.expert_recommend = list
        }else {
          this.expert_recommend = this.expert_recommend.concat(list)
        }
      } else {
        this.$message.error(_res.msg)
      }
    },

    // 热门专家
    async hot(){
      let _res = await hot(
          this.showId,
          1,5
      );
      if (_res.status === 200) {
        var list = []
        list = _res.data;
        list.map(item => {
          let ary = JSON.parse(item.job)
          let arr = []
          ary.map(itm => {
            arr.push(itm.value)
          })
          item.job_text = arr.join('、')
        })
        this.hotList = list
      }else {
        this.$message.error(_res.msg);
      }
    },

    yuyue(id){
      if(this.show_config.login_show == 1 && !this.user) {
        this.$confirm('查看详情需要登录，是否去登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push(`/login?rout=expert&showId=${this.showId}&register_type=${this.register_type}`)
          this.$router.push({
            path:'/login',
            query:{
              rout:`/expert?showId=${this.showId}&register_type=${this.register_type}`
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }else {
        this.$router.push({
          path: '/expertDetail',
          query: {
            id: id,
            name: this.org_info.morgname,
            logo:this.org_info.morglogo,
            tel:this.org_info.tel,
            yuyue: this.show_config.login_yuyue,
            showId: this.showId
          }
        })
      }
    },

    // 跳转
    to() {
      this.$router.push({
        path: '/checkin',
        query: {
          register_type: this.register_type,
          showId: this.showId
        }
      })
    },
  },
  watch:{
    active(){
      this.input = ''
      this.jgList(0)
    }
  }
}
</script>

<style scoped lang="scss">


.box {
  width: 100%;
  background-color: #f2f3f4;

  .boxTop {
    width: 100%;
    height: 100px;
    background-color: #18314f;
    margin-top: -2px;
    padding-top: 60px;

    .name {
      width: 100%;
      text-align: center;
      font-size: 24px;
      letter-spacing: 1px;
      color: #333333;
      font-weight: bold;
      padding-top: 10px;
    }

    .img {
      width: 80px;
      height: 80px;
      border-radius: 40px;
      overflow: hidden;
      background-color: #ffffff;
      margin: 0 auto;


      img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
    }
  }

  .jigou-detail {
    width: 100%;
    background: #0a2240 url("../../assets/images/zjtopBgc.png") no-repeat bottom center;
    padding-top: 30px;
    padding-bottom: 45px;
    .jigou-box {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      padding-bottom: 25px;
      .jigou-btn {
        width: 100%;
        display: flex;
        justify-content: center;
        span {
          width: 168px;
          height: 40px;
          background-color: #ff9600;
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          letter-spacing: 1px;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .jigou-tex {
        width: 100%;
        padding: 30px 0;
        font-size: 14px;
        letter-spacing: 1px;
        color: #999999;
        line-height: 24px;
        background-color: #FFFFFF;
        padding: 20px;
        border-radius: 10px;
      }

      .tab {
        width: 100%;
        height: 90px;
        background-color: #ffffff;
        box-shadow: 0px 0px 43px 0px
        rgba(95, 119, 150, 0.08);
        border-radius: 10px;
        position: absolute;
        left: 0;
        bottom: -88px;
        overflow: hidden;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-top: 20px;
        padding-left: 20px;
        span {
          width: 212px;
          height: 50px;
          background-color: #ffffff;
          border-radius: 10px;
          border: solid 1px #ebebeb;
          font-size: 18px;
          letter-spacing: 1px;
          color: #999999;
          text-align: center;
          line-height: 48px;
          position: relative;
          cursor: pointer;
          margin-right: 20px;
          margin-bottom: 20px;
          &.active {
            background-color: #0a2240;
            border: solid 1px #0a2240;
            color: #ffffff;
          }
          &.active:after {
            content: '';
            width: 14px;
            height: 14px;
            transform: rotate(45deg);
            background-color: #0a2240;
            position: absolute;
            bottom: -7px;
            left: 50%;
            margin-left: -7px;
          }
        }
      }

    }
  }
  .box-end {
    width: 100%;
    padding-top: 70px;
    .search-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .select-box {
        font-size: 16px;
        color: #333333;
        margin-right: 20px;
        span {
          color: #ff9600;
        }
      }

      .input-box {
        flex: 1;
        width: 0;
        display: flex;
        height: 50px;
        overflow: hidden;
        justify-content: space-between;
        border-radius: 5px;

        > div {
          width: 125px;
          height: 50px;
          background-color: #0a2240;
          border-radius: 0px 10px 10px 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          span {
            font-size: 16px;
            color: #ffffff;
          }
          i {
            margin-right: 4px;
            color: #ffffff;
            font-size: 18px;
          }
        }
      }
    }
    .list {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .item {
        width: 386px;
        height: 225px;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 15px;
        margin-right: 20px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .ltem-l {
          width: 112px;
          .img {
            width: 112px;
            height: 134px;
            background-color: #eaeff3;
            border-radius: 5px;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
              object-fit: scale-down;
            }
          }
          .btn {
            width: 112px;
            height: 40px;
            background-color: #ff9600;
            border-radius: 20px;
            text-align: center;
            line-height: 40px;
            font-size: 14px;
            color: #ffffff;
            cursor: pointer;
            margin-top: 10px;
          }
        }
        .ltem-r {
          flex: 1;
          width: 0;
          margin-left: 15px;
          cursor: pointer;
          .name {
            font-size: 20px;
            letter-spacing: 1px;
            color: #333333;
            font-weight: bold;
          }
          .tex {
            font-size: 14px;
            color: #999999;
            line-height: 22px;
            padding-top: 10px;
          }
          .xian {
            width: 212px;
            height: 1px;
            background-color: #dae0e6;
            margin: 15px 0;
          }
          .p {
            width: 100%;
            p {
              font-size: 14px;
              color: #666666;
              text-align: justify;
              position: relative;
              span {
                display: block;
                width: 58px;
                height: 15px;
                color: #ff9f03;
                line-height: 18px;
                background-color: #ffffff;
                position: absolute;
                right: 0;
                bottom: 2px;
                cursor: pointer;
              }
            }

          }
        }
      }
    }
    .asd {
        .item {
          border: 1px solid #e2e2e2;
      }
    }
    .more {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-top: 15px;
      padding-bottom: 35px;
      p {
        width: 266px;
        height: 40px;
        background-color: #f3f6f9;
        border-radius: 20px;
        border: solid 1px #cbceda;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #0a2240;
        opacity: 0.5;
        cursor: pointer;
        i {
          font-size: 16px;
          color: #0a2240;
          opacity: 0.5;
          margin-left: 5px;
        }
      }
    }
    .bac {
      width: 100%;
      background-color: #ffffff;
      padding: 60px 0;
      .tit {
        font-size: 26px;
        letter-spacing: 1px;
        color: #333333;
        font-weight: bold;
      }
      .list {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-top: 20px;
        .coniter {
          width: 224px;
          height: 364px;
          background-color: #ffffff;
          border-radius: 10px;
          border: solid 1px #e2e2e2;
          margin-right: 20px;
          position: relative;
          overflow: hidden;
          &:hover {
            .name {
              display: none;
            }
            .tex {
              display: none;
            }
            .img {
              width: 100%;
              height: 100%;
            }
            .detail {
              display: block;
            }
          }
          &:nth-child(5n) {
            margin-right: 0;
          }
          .img {
            width: 100%;
            height: 267px;
            img {
              width: 100%;
              height: 100%;
              object-fit: scale-down;
            }
          }
          .name {
            width: 100%;
            padding: 8px 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            b {
              font-size: 20px;
              letter-spacing: 1px;
              color: #333333;
              font-weight: bold;
            }
            span {
              font-size: 14px;
              letter-spacing: 1px;
              color: #ff9600;
            }
          }
          .tex {
            width: 100%;
            padding: 0 15px;
            font-size: 14px;
            color: #999999;
            line-height: 22px;
          }
          .detail {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background-color: rgba(10, 34, 64, .7);
            z-index: 10;
            padding: 12px;
            display: none;
            .d-name {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 40px;
              cursor: pointer;
              .d-b {
                font-size: 26px;letter-spacing: 1px;
                color: #ffffff;
                font-weight: bold;
              }
              .d-s {
                font-size: 14px;
                letter-spacing: 1px;
                color: #ffffff;
              }
            }
            .d-tex {
              font-size: 14px;
              color: #ffffff;
              width: 100%;
              padding-top: 15px;
              cursor: pointer;
            }
            .d-xian {
              width: 100%;
              height: 1px;
              background-color: #ffffff;
              opacity: 0.3;
              margin: 15px 0;
              cursor: pointer;
            }
            .d-p {
              width: 100%;
              font-size: 14px;
              color: #ffffff;
              line-height: 22px;
              position: relative;
              cursor: pointer;
              span {
                font-size: 14px;
                color: #ff9f03;
                position: absolute;
                bottom: 2px;
                right: 0;
                cursor: pointer;
              }
            }
            .d-btn {
              width: 100%;
              margin-top: 15px;
              justify-content: center;
              display: flex;
              span {
                width: 102px;
                height: 40px;
                background-color: #ff9600;
                border-radius: 20px;
                font-size: 14px;
                color: #ffffff;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}

</style>
